document.addEventListener("DOMContentLoaded", function () {
  if (localStorage.getItem("cookieAccepted")) return;

  let banner = document.createElement("div");
  banner.className = "cookie-banner cl";
  banner.innerHTML = `
      <p>При использовании данного сайта, вы подтверждаете свое согласие на использование файлов cookie и других похожих технологий в соответствии с настоящим уведомлением.</p>
      <div class="buttons">
        <button class="button cl" id="cookie-accept">
            <span class="overlay"></span>
            <span class="t">Хорошо</span>
            <span class="plus-ico cb"></span>
        </button>
        <a class="button cl" target="_blank" href="https://medisorb.ru/politika-obrabotki-personalnyh-dannyh/">
            <span class="overlay"></span>
            <span class="t">Подробнее</span>
            <span class="plus-ico cb"></span>
        </a>
      </div>
    `;
  document.body.appendChild(banner);

  document
    .getElementById("cookie-accept")
    .addEventListener("click", function () {
      localStorage.setItem("cookieAccepted", "true");
      banner.remove();
    });
});
